export const NetworkRequest = {
  AdministrationGetUsage: "AdministrationGetUsage",
  SignupRequest: "SignupRequest",
  SignupGetName: "SignupGetName",
  SignupConfirm: "SignupConfirm",
  StateGetList: "StateGetList",
  RequestProfilePage: "RequestProfilePage",
  ResetPasswordRequest: "ResetPasswordRequest",
  ResetPasswordGetEmail: "ResetPasswordGetEmail",
  ResetPasswordConfirm: "ResetPasswordConfirm",
  ChangePassword: "ChangePassword",
  UploadPhoto: "UploadPhoto",
  UserUpdate: "UserUpdate",
};
